import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../config/config'; // Importing development configuration
import { persons } from '../../models/persons'; // Importing persons model

/**
 * Class representing the Information Machine Register View.
 * @extends JetView
 */
export default class InformationMachineRegisterView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const lenguages = [
            // Language options for selection
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];
        const main = {
            // Main form layout
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for user ID
                            name: 'Id',
                            label: _('Número de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Número de usuario'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for login
                            name: 'Login',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for last IP address
                            name: 'LastIPaddress',
                            label: _('Última dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Última dirección IP'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for last modified user
                            name: 'LastModifiedUser',
                            label: _('Último usuario modif'),
                            labelPosition: 'top',
                            placeholder: _('Último usuario modif'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'State:combo',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // State options
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language selection
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages, // Language options
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'Name',
                            label: _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId',
                            id: 'country',
                            localId: 'Country:combo',
                            label: _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Country options (to be populated)
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'CurrencyId',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Currency options (to be populated)
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for creation date
                            name: 'CreatedLocalDate',
                            label: _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Fecha de Creación'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for last login date
                            name: 'LastLoginLocalDate',
                            label: _('Fecha última entrada'),
                            labelPosition: 'top',
                            placeholder: _('Fecha última entrada'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for last modified date
                            name: 'LastDateModified',
                            label: _('Última Fecha modif'),
                            labelPosition: 'top',
                            placeholder: _('Última Fecha modif'),
                            disabled: true, // Disabled input
                        },
                    ],
                },
            ],
        };
        const options_main = {
            // Configuration options layout
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'richselect', // Dropdown for special status selection
                            name: 'SpecialStatus',
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Special status options
                                { id: 'A', value: _('Active') },
                                { id: 'I', value: _('Inactive') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for pin agent selection
                            name: 'Pinagent',
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Pin agent options
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for locked sales selection
                            name: 'Lockedsales',
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Locked sales options
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for print receipt box selection
                            name: 'PrintReceiptBox',
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Print receipt options
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for allows recharges selection
                            name: 'AllowsRecharges',
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Allows recharges options
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for activate registration selection
                            name: 'ActivateRegistration',
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Activate registration options
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for latitude
                            name: 'Latitud',
                            type: 'number',
                            label: _('Latitud'),
                            labelPosition: 'top',
                            placeholder: _('Latitud'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for longitude
                            name: 'Longitud',
                            type: 'number',
                            label: _('Longitud'),
                            labelPosition: 'top',
                            placeholder: _('Longitud'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for IP
                            name: 'IP',
                            type: 'number',
                            label: _('IP'),
                            labelPosition: 'top',
                            placeholder: _('IP'),
                            disabled: true, // Disabled input
                        },
                    ],
                },
            ],
        };
        const betshop_details = {
            // Betshop details layout
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: _('Descripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for phone number
                            name: 'Phone',
                            type: 'number',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for concessionaire selection
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Concessionaire options
                                { id: 1, value: 'Banana' },
                                { id: 2, value: 'Papaya' },
                                { id: 3, value: 'Apple' },
                            ],
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for subconcessionaire selection
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Subconcessionaire options (to be populated)
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for region selection
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Region options (to be populated)
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'richselect', // Dropdown for city selection
                            name: 'CityId',
                            id: 'City',
                            localId: 'City:combo',
                            label: _('Ciudad'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // City options (to be populated)
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            disabled: true, // Disabled input
                        },
                    ],
                },
            ],
        };
        const center_right = {
            // Center right layout for additional settings
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            type: 'number',
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for commission reloads
                            name: 'CommissionReloads',
                            type: 'number',
                            label: _('Comisión recargas'),
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            type: 'number',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            type: 'number',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                            disabled: true, // Disabled input
                        },
                    ],
                },
            ],
        };
        const right = {
            // Right section layout (currently empty)
            margin: 5,
            rows: [],
        };
        const upper_section = {
            // Upper section layout with accordions
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion', // Accordion for grouping sections
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Principales'), // Main data section header
                                    body: {
                                        rows: [main], // Main data layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Configuración'), // Configuration data section header
                                    body: {
                                        rows: [options_main], // Configuration options layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Punto de venta'), // Betshop data section header
                                    body: {
                                        rows: [betshop_details], // Betshop details layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Configuración Punto de Venta'), // Point of sale configuration section header
                                    body: {
                                        rows: [center_right], // Center right layout
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const buttons = {
            // Button layout for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        // Clear action
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Save action
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent('customer:save', [newdata]); // Trigger save event
                            this.show('betShop'); // Navigate to betShop view
                        } else {
                            webix.message({
                                // Show error message
                                title: '¡Error!',
                                type: 'alert-error',
                                text: 'Completa los campos...',
                            });
                        }
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen
        return {
            // Return the main form configuration
            view: 'form',
            id: 'formId',
            scroll: 'y',
            css: 'out',
            rows: [
                upper_section, // Upper section with accordions
            ],
            rules: {
                // Validation rules
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        var vthis = this; // Reference to the current instance
        this.on(this.app, 'form:update', (id) => {
            // Event listener for form update
            persons.waitData.then(() => {
                // Wait for persons data to load
                webix.ajax().get(
                    devConfig.geturlApi() + 'Client/GetClientSpById', // API call to get client by ID
                    'id=' + id,
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handling
                            webix.message('Error! ');
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handling
                            text = JSON.parse(text); // Parse response
                            vthis.app.callEvent('agent:updatedata', [
                                text[0], // Trigger agent update event with data
                            ]);
                        },
                    },
                );
            });
        });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsCountries = $$('country').getList(); // Get country dropdown list
                    optionsCountries.clearAll(); // Clear existing options
                    optionsCountries.parse(data.Data); // Populate with new data
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type for request
                        })
                        .post(
                            devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels?isList=1', // API call to get agents
                            '',
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handling
                                    webix.message('Error! ');
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handling
                                    var data = JSON.parse(
                                        text
                                            .replace(/"UserName"/g, '"id"') // Normalize response keys
                                            .replace(/"Name"/g, '"value"'),
                                    );
                                    if (data.Data.Children == null) {
                                        // Check for children
                                        $$('Concessionaire').hide(); // Hide if no children
                                        $$('Subconcessionaire').hide(); // Hide if no children
                                    } else {
                                        var options = $$('Concessionaire').getList(); // Get concessionaire list
                                        options.clearAll(); // Clear existing options
                                        options.parse(data.Data.Children); // Populate with new data
                                    }
                                    vthis.app.callEvent('form:update', [
                                        vthis.getParam('user', true), // Trigger form update event
                                    ]);
                                },
                            },
                        );
                },
            });
        this.on(this.app, 'agent:updatedata', (person) => {
            // Event listener for agent data update
            form.setValues(person); // Set form values with person data
        });
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Change event for country selection
            var optionscountries = this.getList().getItem(newv); // Get selected country
            if (optionscountries != undefined) {
                // Check if country is defined
                var optionscurrencies = $$('currency').getList(); // Get currency dropdown list
                optionscurrencies.clearAll(); // Clear existing options
                optionscurrencies.parse(optionscountries.currencies); // Populate with new data
                var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region dropdown list
                optionsProvinceRegions.clearAll(); // Clear existing options
                optionsProvinceRegions.parse(optionscountries.departments); // Populate with new data
            }
        });
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Change event for province/region selection
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList(); // Get city dropdown list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                // Check if province/region is defined
                optionsCity.parse(optionsProvinceRegions.cities); // Populate with new data
            }
        });
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            // Change event for concessionaire selection
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected concessionaire
            var optionsCity = $$('Subconcessionaire').getList(); // Get subconcessionaire dropdown list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                // Check if province/region is defined
                optionsCity.parse(optionsProvinceRegions.Children); // Populate with new data
            }
        });
    }

    /**
     * Retrieves localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Populate position combo
        let t_options = webix.copy(getTags()); // Get tags options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Populate tags combo
        let c_options = webix.copy(getCities()); // Get cities options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Populate cities combo
    }
}

// FILE DOCUMENTED
